export enum RootWallet {
  NFID = "NFID",
  II = "II",
}
